import { Controller } from "@hotwired/stimulus"

// Shows and hides the table's metric columns. The choice is remembered in the browser per view, and is applied again each time
// the table is replaced by a sort, a search or a page change.
export default class extends Controller {
  static targets = ["toggle"]
  static values = { key: String, hiddenDefault: Array }

  connect() {
    this.hidden = this.load()
    this.toggleTargets.forEach((box) => { box.checked = !this.hidden.includes(box.dataset.col) })
    this.paint()
  }

  apply() {
    this.hidden = this.toggleTargets.filter((box) => !box.checked).map((box) => box.dataset.col)
    this.save()
    this.paint()
  }

  paint() {
    this.element.querySelectorAll("th[data-col], td[data-col]").forEach((cell) => {
      cell.hidden = this.hidden.includes(cell.dataset.col)
    })
  }

  get storageKey() {
    return `ppc.columns.${this.keyValue}`
  }

  load() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(this.storageKey))
      if (Array.isArray(stored)) return stored
    } catch (_error) { /* private window or blocked storage: use the defaults */ }
    return [...this.hiddenDefaultValue]
  }

  save() {
    try { window.localStorage.setItem(this.storageKey, JSON.stringify(this.hidden)) } catch (_error) { /* not remembered */ }
  }
}
